import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from 'react-i18next';


const Login = () => {
  const { t, i18n } = useTranslation();
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const changeLanguage = (e) => {
    const selectedLang = e.target.value;
    i18n.changeLanguage(selectedLang);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`/api/login`, credentials);

      if (response.data.token && response.data.role) {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.role);

        // ✅ Запитуємо повного користувача
        const userRes = await axios.get(`/api/user/me`, {
          headers: { Authorization: `Bearer ${response.data.token}` },
        });

        setUser({
          ...userRes.data,
          role: response.data.role,
          token: response.data.token,
        });

        if (response.data.role === "admin") {
          navigate("/dashboard");
        } else {
          navigate("/dashboard");
        }
      } else {
        setError(t("loginError"));
      }
    } catch (error) {
      setError(t("wrongLogin"));
    }
  };


  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Header */}
      <header className="bg-primary text-white text-center py-3">
        <h1>GoDrive Partner</h1>
      </header>

      {/* Centered login form */}
      <main className="flex-fill d-flex justify-content-center align-items-center">
        <div className="card p-4 shadow" style={{ width: "100%", maxWidth: "400px" }}>
          {error && <div className="alert alert-danger">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">{t("email")}:</label>
              <input
                type="email"
                name="email"
                className="form-control"
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">{t("password")}:</label>
              <input
                type="password"
                name="password"
                className="form-control"
                onChange={handleChange}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100">
              {t("login")}
            </button>
          </form>
          <div className="mt-4 text-center">
            <select
              id="language-select"
              className="form-select"
              value={i18n.language}
              onChange={changeLanguage}
              style={{ maxWidth: "150px", margin: "0 auto" }}
            >
              <option value="en">English</option>
              <option value="ua">Українська</option>
              <option value="pl">Polski</option>
              <option value="ru">русский</option>
            </select>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-light text-center py-3 mt-auto">
        <small>© 2025 GoDrive. Всі права захищені.</small>
      </footer>
    </div>
  );
};

export default Login;
